import Api from '@/services/Api';
import _ from 'lodash';
import MetodosGlobais from '@/utils/MetodosGlobais';

const RECURSO = '/sp360Analytics';

export default 
{
    dadosDeAcessosNoIntervalo,
    contabilizarAcesso
};

function dadosDeAcessosNoIntervalo({dataInicio, dataFim, intervalo }){
    let params = {'dataInicio ': dataInicio, 'dataFim ': dataFim, 'intervalo' : intervalo};
    return Api.get(`${RECURSO}/dadosDeAcessosNoIntervalo${MetodosGlobais.createEncodeQuery(params)}`)
}

function contabilizarAcesso(payload){
    return Api.post(`${RECURSO}/registrarAcesso`, payload);
}